export const projects = [
    {
        title: 'SOLID Principles',
        subtitle: 'using Typescript',
        description:
            'This small web app depicts various S.O.L.I.D. principles and illustrates with JS code snippets.',
        image: './solid-logo.gif',
        link: 'http://solid-in-js.sujitsingh.in/',
    },
    {
        title: 'Micro Frontend',
        subtitle: 'using Webpack Module Federation',
        description: `This small web app demonstrates MF by making use of Webpack's Module Federation.`,
        image: './mfe-logo.gif',
        link: 'http://mfe-react-host.sujitsingh.in/',
    },
];

export const testimonials = [
    {
        quote: 'Sujit, you were instrumental in our wins. Thank you.',
        image: './rohit.jpeg',
        name: 'Rohit Ghatol',
        company: 'Centric Software',
    },
    {
        quote: 'Thank you so much Sujit for your diligence, your efforts and your hardwork. You have been an outstanding member of the team!!',
        image: './raymond.jpeg',
        name: 'Raymond Maggiore',
        company: 'Centric Software',
    },
    {
        quote: 'Sujit is proactive, result oriented, responsible and technically sound employee and he is always ready to put all his energy and time to get the job done. He has an exceptional troubleshooting and analytical skills. Always ready to help his team members. He is kind of senior which every junior wants to have.',
        image: './ganesh-kaspate.jpeg',
        name: 'Ganesh Kaspate',
        company: 'Ex-colleague in EXCELLARATE',
    },
    {
        quote: 'It was really a good experience working with Sujit. I admire the patience with which he used to work on complex tasks and hard work he put in, in everything he did.',
        image: './avatar.jpeg',
        name: 'Raeesaa Metkari',
        company: 'Ex-colleague in EXCELLARATE',
    },
];

export const skills = [
    'JavaScript',
    'React',
    'Node',
    'Angular',
    'GraphQL',
    'Material UI',
    'AWS - EC2, S3, Lambda, Load Balancers',
    'Docker',
    'Github Actions',
];



// WEBPACK FOOTER //
// ./src/data.js